'use client';

import {createContext, useContext, useEffect, useMemo, useState} from 'react';
import {subjectConcerns as subjectConcernsDE} from './subject-concerns.de.js';
import {subjectConcerns as subjectConcernsAT} from './subject-concerns.at.js';
import ModelContainer from '@core/scripts/components/model-container.js';

const model = ModelContainer.get('servicePageModel');

const subjectConcerns = (() => {
    if (model.tenantCountry === 'de') {
        return subjectConcernsDE;
    } else if (model.tenantCountry === 'at') {
        return subjectConcernsAT;
    } else {
        throw new Error(`Unsupported tenant country: ${model.tenantCountry}`);
    }
})();

function getParameterFromHash(name) {
    const hash = location.hash.substring(1);
    const params = new URLSearchParams(hash);
    return params.get(name);
}

const ContactFormContext = createContext(undefined);

export const ContactFormProvider = ({children, positions}) => {
    const [formValues, setFormValues] = useState(() => {
        const firstName = getParameterFromHash('firstName') ?? '';
        const lastName = getParameterFromHash('lastName') ?? '';
        const email = getParameterFromHash('email') ?? '';

        let subject = getParameterFromHash('subject') ?? '';
        let subjectIndex = '0';
        let concern = getParameterFromHash('concern') ?? '';
        let concernIndex = '0';

        const foundSubject = subject !== '' ? subjectConcerns.find((s) => s.subject === subject) : undefined;
        if (foundSubject) {
            subjectIndex = foundSubject.value;
            const foundConcern = concern !== '' ? foundSubject.concerns.find((c) => c.concern === concern) : undefined;
            if (foundConcern) {
                concernIndex = foundConcern.value;
            } else {
                concern = '';
            }
        } else {
            subject = '';
        }

        //clear hash in url
        const newUrl = window.location.href.split('#')[0];
        window.history.replaceState({}, document.title, newUrl);

        return {
            firstName,
            lastName,
            customerId: '',
            email,
            emailCompare: email,
            subjectIndex,
            subject,
            concernIndex,
            concern,
            message: '',
            termsAndConditionsAgreement: false,
        };
    });

    const value = useMemo(
        () => ({
            formValues,
            setFormValues,
        }),
        [formValues, setFormValues],
    );

    return <ContactFormContext.Provider value={value}>{children}</ContactFormContext.Provider>;
};

/**
 * Check for undefined since the defaultValue of the context is undefined. If
 * it's still undefined, the provider component is missing.
 */
export function useContactForm() {
    const context = useContext(ContactFormContext);
    if (!context) throw new Error('Provider missing!');
    return context;
}
